import React, {Component} from 'react';
import styles from './css-modules/themes.module.scss';
import { Link } from "react-router-dom";

class Themes extends Component {
  setOpacity = (id, opacity) => {
    document.getElementById(id).style.opacity = opacity;
  }

  render() {
    return (
      <div className={styles.themes_container} style={window.innerWidth > 1024 ? {height: '100vh'} : {height: window.innerHeight}}>
        {window.innerWidth < 1025 && <img alt="" className={styles.absoluteBack} src={this.props.image}></img>}

        {this.props.images && this.props.images.length > 0 && this.props.images.map((image, index) => (
          <img key={image.id} id={image.id} alt="Theme background" src={image.image} className={styles.absoluteBg}/>
        ))}

        <div className={styles.themes_content}>
          <p className={styles.browse_proj_heading}>Explore a theme</p>
          {this.props.themes && this.props.themes.length > 0 && this.props.themes.map((theme, index) => (
            <div key={index} className={styles.navItem}>
              <Link to={theme.linkTo} style={{textDecoration: 'none'}}>
                <p className={styles.projectTitle} onMouseOver={() => this.setOpacity(theme.linkTo, 1)} onMouseOut={() => this.setOpacity(theme.linkTo, 0)}><span className={styles.underline}>{theme.theme}</span></p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Themes;
